import axios from "axios";
import { URL } from "../constants/constant";

/**
 * Send event to mongo
 *
 * @async
 * @function forwardAnalyticsEvent
 * @param {string} eventName - The URL to download from.
 * @param {object} eventData - The URL to download from.
 * @return {Promise<string>} The data from the URL.
 */
export const forwardAnalyticsEvent = (eventName, eventData) => {
    const timestamp = new Date();
    let loggedInUserName = undefined;
    
    try {
        const loggedInUser = JSON.parse(localStorage.getItem("userDetails"));
        loggedInUserName = loggedInUser.email;
        loggedInUserName = loggedInUserName.split('@')[0]
    } catch (e) {
        console.log(e);
    }
    const flattenedEvent = {
        eventName: eventName,
        createdAt: timestamp.toISOString(),
        user: loggedInUserName, 
        ...eventData,
    };
    if (!loggedInUserName) {
        console.log("Skipping analyticsEvent --> user not logged in")
        return;
    }
    
    try {
        axios
            .post(URL.demystify_url + "userEvents/addEvent", flattenedEvent)
            .then((response) => {
                console.log(response);
            })
            .catch((error) => {
                console.log(error);
            });
    } catch (error) {
        console.log(`Error pushing event : ${JSON.stringify(flattenedEvent)}  due to error ${error.toString()}`);
    }
};
